<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Construction Projects'
            :titleIcon='constructionDivision.icon'
            :titleIconColor='constructionDivision.icon_color'
            :loading='isLoading'
            showAdd
            @add='openAdd'
          >
            <template v-slot:toolbarButtons>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              dense
              :headers='headers'
              :items='projects'
              :search='search'
              :items-per-page='25'
              sort-by='name'
              no-data-text='No Construction Projects Found'
              @click:row='openProject'
            >
              <template v-slot:item.start_date='{ item }'>
                {{ item.start_date | shortDate }}
              </template>
              <template v-slot:item.end_date='{ item }'>
                {{ item.end_date | shortDate }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

<!-- CREATE NEW PROJECT DIALOG -->
    <wc-dialog
      :showDialog='addDialog'
      :title='"New " + constructionDivision.division + " Project"'
      :icon='constructionDivision.icon'
      @cancel="cancelAdd"
      @save='createProject'
      width='400'
      :loadingButtons='isLoading'
      :disableButtons='!isFormValid'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          label='Project name'
          :rules='[rules.required]'
          v-model='newProject.name'
          :hint='projectName.hint'
          persistent-hint
          :append-outer-icon='projectName.icon'
          @click:append-outer='useOwnerName'
        ></v-text-field>
 
        <client-form-search
          ref='clientPicker'
          v-model='newProject.owner'
          label='Select a Client'
          showAdd
        ></client-form-search>
      </v-form>
    </wc-dialog>
    
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
import ClientFormSearch from '@/modules/clients/components/ClientFormSearch'
import projectsAPI from '@/modules/projects/api/projects'
import constructionAPI from '@/modules/construction/api/construction'

export default {
  name: 'construction-dashboard',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isFormValid: false,
    addDialog: false,
    newProject: {},
    newProjectDetail: {},
    projects: [],
    search: '',
    headers: [
      { text: 'Project Name', value: 'name' },
      { text: 'Number', value: 'number' },
      { text: 'Address', value: 'site_address' },
      { text: 'City', value: 'site_city' },
    ]
  }),
  mounted () {
    this.getProjects()
  },
  computed: {
    constructionDivision () {
      return this.$store.state.misc.divisions.find(d => d.division === 'Construction')
    },
    projectName () {
      if (this.newProject.client) {
        return { hint: "Click avatar to use owner's name", icon: "mdi-account" }
      } else if (!this.newProject.client && this.newProject.name) {
        return { hint: "Click avatar to delete project name", icon: "mdi-account-cancel" }
      }
      return { hint: "", icon: "" }
    },
  },
  methods: {
    async getProjects () {
      this.isLoading = true
      let projects = await projectsAPI.getDivisionProjects(this.constructionDivision)
      this.projects = _.filter(projects, p => !p.archived)
      this.isLoading = false
    },
    openProject (item) {
      this.$router.push({ name: 'ConstructionOverview', params: { id: item.id } })
    },
    cancelAdd () {
      this.$refs.form.reset()
      this.$refs.clientPicker.clearResults()
      this.addDialog = false
    },
    openAdd () {
      this.addDialog = true
    },
    async createProject () {
      this.isLoading = true
      this.newProject.division = this.constructionDivision.id
      let project = await projectsAPI.createProject(this.newProject)
      this.newProjectDetail.project = project.id
      let detail = await constructionAPI.createConstructionProject(this.newProjectDetail)
      console.log("Const. Proj. detail created: " + detail.id)
      this.openProject(project)
      this.isLoading = false
    },
    useOwnerName () {
      if (this.newProject.client) {
        const client = this.$refs.clientPicker.$data.selected
        if (client.is_company && !client.name) {
          alert('Error - No Company name has been set!')
          return
        } else if (!client.is_company && !client.last_name) {
          alert("Error - Client's last name has been set!")
          return
        }
        let newName = client.is_company ? client.name : client.last_name
        this.newProject.name = newName
      } else {
        this.newProject.name = ""
        this.$refs.form.resetValidation()
      }
    },
  },
  components: {
    'client-form-search': ClientFormSearch
  }
}
</script>